export default __webpack_public_path__ + "static/media/Logo-dark-bkg.4a126f7b.svg";